import { IonAlert, IonCard, IonLabel } from "@ionic/react";
import React, {  useState } from "react";
import { utilService } from "../../../../../../../../../../services/utilService";
import "./NotesCard.scss";
import {
  RespUpdatedNotesCardInterface,
  updatedNotesCardParams,
} from "./Models/UpdatedNotesCard.model";
import { useToast } from "@agney/ir-toast";
import { notesContainerService } from "../../NotesContainer.service";
import { statusBoardService } from "../../../../../../../../StatusBoard.service";
import {  DataChanged } from "../../Models/NotesContainer.model";
import { statusBoardSocketService } from "../../../../../../../../StatusBoardSocketService";

interface notesParams {
  notesData: DataChanged;
  setNotesContainerData?:any;
}

const NotesCard: React.FC<notesParams> = (props) => {
  const [isShowAlert, setIsShowAlert] = useState(false);

  const [isLoaderActive, setLoaderStatus] = useState(true);

  const Toast = useToast();

  async function updateNotesList(addParams: updatedNotesCardParams) {
    setLoaderStatus(true);
    const respUpdatedNotesCardResult: RespUpdatedNotesCardInterface =
      await notesContainerService.getUpdatedNotesCardList(addParams);
    if (respUpdatedNotesCardResult.isSuccess) {
      // const notesCard = document.getElementById(
      //   `notesCardId-${props.notesData.id}`
      // );
      // notesCard?.style.setProperty("display", "none");
      if(props?.setNotesContainerData){
        props?.setNotesContainerData(respUpdatedNotesCardResult?.displayUpdatedNotesCard)
      }
      console.log("test respUpdatedNotesCardResult",respUpdatedNotesCardResult)
      const socketParams = {
        type: "notes",
      };
      statusBoardSocketService.sendSbInputSocketParams(socketParams);
      Toast.success("Note removed successfully");
    } else {
      notesContainerService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }

  const proceedDeleteNote = (key: number) => {
    const addParams = {
      bedId: statusBoardService.rowData.id,
      statusBoardID: statusBoardService.statusBoardId,
      remove_note_id: key,
      reg_code: utilService.getNetwork(),
    };
    updateNotesList(addParams);
  };

  return (
    <IonCard
      className="notes-card-wrapper"
      id={`notesCardId-${props.notesData.id}`}
    >
      <div className="time-data">
        <IonLabel
          className="close"
          onClick={() => setIsShowAlert(true)}
          padding-right
        >
          <span className="input-icon icon-close"></span>
        </IonLabel>
        <IonAlert
          isOpen={isShowAlert}
          onDidDismiss={() => setIsShowAlert(false)}
          cssClass="sms-alert"
          header="Confirmation!"
          message="Are you sure you want to delete note?"
          buttons={[
            {
              text: "NO",
              role: "cancel",
              cssClass: "secondary",
            },
            {
              text: "OK",
              handler: () => {
                proceedDeleteNote(props.notesData.id);
              },
            },
          ]}
        />
      </div>
      <div className="notes-card-data">
        <div className="data-header">
          <span className="doc-name">{props.notesData.userName}</span>

          <span className="notes-time">{props.notesData.dateTime}</span>
        </div>
        <div className="text-message">{props.notesData.note}</div>
      </div>
    </IonCard>
  );
};

export default NotesCard;
